module.exports = __webpack_public_path__ + "img/traditional-controller.5cd40ab6.jpg";